import axios from 'axios';
import { GET_CITY, ADD_CITY } from "../types";
import { setAlert } from './alert';

export const getCity = () => async (dispatch) => {
    const url = `${process.env.REACT_APP_BE_URL}/cities`;
    axios
        .get(url)
        .then((res) => {
            dispatch({ type: GET_CITY, payload: res?.data?.data });
        })
        .catch((error) => {
            dispatch(setAlert(error?.response?.data?.error?.message || 'Internal Server Error', 'error', 5000));
        });
};

export const addCity = (cityName) => async (dispatch) => {
    const token = localStorage.getItem('jwtToken');
    const url = `${process.env.REACT_APP_BE_URL}/cities`;
    const headers = {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
    };
    try {
        const res = await axios.post(url, { name: cityName }, { headers });
        const newCity = res?.data?.data;
        dispatch({ type: ADD_CITY, payload: newCity });
        dispatch(setAlert('City added successfully', 'success', 5000));
        dispatch(getCity());
        return { status: 'success', data: newCity };
    } catch (error) {
        const message = error?.response?.data?.error?.message || 'Failed to add city';
        dispatch(setAlert(message, 'error', 5000));
        return { status: 'error', message };
    }
};